<div class="w-full h-[600px] object-cover">

  @for (img of images; track $index; let i = $index) {
    <img [src]="img"
         class="absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000"
         [class.opacity-100]="i === currentIndex"
         [class.opacity-0]="i !== currentIndex">
  }

    <div class="absolute top-0 left-0 w-full h-full bg-black opacity-30 pointer-events-none"></div>


  <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-white">
    <ng-content></ng-content>
  </div>

  <!-- <div class="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
    @for (img of images; track $index; let i = $index) {
      <button (click)="currentIndex = i"
              class="w-3 h-3 rounded-full transition-colors duration-300"
              [class.bg-white]="i === currentIndex"
              [class.bg-gray-700]="i !== currentIndex">
      </button>
    }
  </div> -->

</div>
